import { ROUTES } from "./routes";

export const NAV_LINKS = [
  { to: ROUTES.home, labelKey: "Home" },
  { to: ROUTES.about, labelKey: "About Us" },
  { to: ROUTES.projects, labelKey: "Our Projects" },
  { to: ROUTES.products, labelKey: "Products" },
  { to: ROUTES.services, labelKey: "Services", mobileLabelKey: "Our Services" },
  { to: ROUTES.contact, labelKey: "Contact Us" },
];
